import { NgModule } from '@angular/core';
import { LoginComponent } from './components/login.component';
import { FormsModule } from '@angular/forms';
import { LoginService } from './services/login.service';
import { CommonModule } from '@angular/common';
import { AnalyticsCoreURLService } from '../../reporting/analytics-core/services/analytics-core.url.service';
import { SsoLoginComponent } from './ssologin/ssologin.component';

@NgModule({
	imports: [FormsModule, CommonModule],
	declarations: [LoginComponent, SsoLoginComponent],
	providers: [LoginService, AnalyticsCoreURLService],
	exports: [LoginComponent, SsoLoginComponent]
})
export class LoginModule {}
